module.exports = __webpack_public_path__ + "img/ufabet.26708bfc.png";